import Vue from 'vue'
import SvgIcon from '../../components/svg-icon'

Vue.component('svg-icon', SvgIcon)

const req = require.context('./icons', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
